import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TitulacionRoutingModule } from './titulacion-routing.module';
import { ListaComponent } from './lista/lista.component';


//importaciones externas
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CrudModule } from "../../crud/crud.module";
import { MenuModule } from "../../menu/menu.module";
import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';
import { PipesModule } from '../../pipes/pipes.module';

import { AuthService } from '../../auth.service';

import { ParcialModule } from '../../parcial/parcial.module';

//crud
import { CrudService } from '../../crud/crud.service';
//fin crud
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { NgSelect2Module } from "ng-select2";
import { BloquearPantallaModule } from 'app/bloquear-pantalla/bloquear-pantalla.module';
import { TramiteTituloComponent } from './tramite-titulo/tramite-titulo.component';

@NgModule({
  declarations: [
    ListaComponent,
    TramiteTituloComponent
  ],
  imports: [
    CommonModule,
    TitulacionRoutingModule,
    CrudModule,
    MenuModule,
    FormsModule,
    ReactiveFormsModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    PaginacionModule,
    PipesModule,
    ParcialModule,
    NguiAutoCompleteModule,
    NgSelect2Module
  ],
  providers: [AuthService, CrudService]
})
export class TitulacionModule { }
